// internal deps
import React, { memo } from "react";

// helpers
import { getCloudinaryUrl } from "@swiggy-private/core-ui";

// Components
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// styles
import {
    WarningIconContainer,
    ErrorImageWrapper,
    ErrorContainer,
    ErrorTextWrapper,
    BodyText,
    ErrorTopContainer,
} from "../styles";

// constants
import { TOING_PC_TEST_IDS } from "@swiggy-private/cart-test-ids";

// interfaces
interface IErrorStateHalfCardProps {
    icon?: string;
    title?: string;
    subtitle?: string;
    errorImage?: string;
}

const ErrorStateHalfCard: React.FC<IErrorStateHalfCardProps> = ({ icon, title, subtitle, errorImage }) => {
    return (
        <ErrorContainer data-testid={TOING_PC_TEST_IDS.ERROR_CONTAINER}>
            <ErrorTopContainer>
                {icon && (
                    <WarningIconContainer>
                        <Image src={getCloudinaryUrl(icon)} alt="error" />
                    </WarningIconContainer>
                )}
                <ErrorTextWrapper>
                    <Text
                        variant="V2.subheading1.neutral.black"
                        color="text_Highest_Emphasis"
                        data-testid={TOING_PC_TEST_IDS.ERROR_TITLE}
                    >
                        {title}
                    </Text>
                    <BodyText
                        variant="V2.body2.neutral.regular"
                        color="text_High_Emphasis"
                        data-testid={TOING_PC_TEST_IDS.ERROR_SUBTITLE}
                    >
                        {subtitle}
                    </BodyText>
                </ErrorTextWrapper>
            </ErrorTopContainer>

            {errorImage && (
                <ErrorImageWrapper>
                    <Image src={getCloudinaryUrl(errorImage)} alt="error detail" />
                </ErrorImageWrapper>
            )}
        </ErrorContainer>
    );
};

export default memo(ErrorStateHalfCard);
